import { Suspense } from 'react';
import { Route, Routes } from 'react-router-dom';
import { Head } from '@unhead/react';

import { ToastContainer } from '@rewardopl/react-toast';

import colors from '@rewardopl/styles/colors';

import { GlobalStyle } from './root.styles';

import AuthGate from './auth_gate';
import ErrorBoundary from './error_boundary';
import OnlineMonitor from './online_monitor';
import AuthCallback from './pages/auth/callback';
import DashboardPage from './pages/dashboard';
import ErrorPage from './pages/error';
import LoginPage from './pages/login';
import OfflinePage from './pages/offline';
import OnboardingPage from './pages/onboarding';
import PasswordResetPage from './pages/password_reset';
import PasswordResetConfirmationPage from './pages/password_reset_confirmation';
import RegisterPage from './pages/register';
import UnlockPage from './pages/unlock';
import VerifyPage from './pages/verify';
import SplashScreen from './splash_screen';

import { isLoggedIn, isLoggedOut } from '../helpers/authorization';

import { SHOULD_DISABLE_REGISTER_PAGE } from '../constants';

export default function Root() {
  return (
    <>
      <GlobalStyle />
      <Head>
        <meta name="theme-color" content={colors.background} />
      </Head>
      <ToastContainer position="top-right" />
      <ErrorBoundary fallback={<ErrorPage />}>
        <OnlineMonitor fallback={<OfflinePage />}>
          <Suspense fallback={<SplashScreen />}>
            <Routes>
              <Route path="auth/*" element={<AuthCallback />} />
              <Route
                path="login/*"
                element={
                  <AuthGate anyOf={isLoggedOut}>
                    <LoginPage />
                  </AuthGate>
                }
              />
              <Route
                path="password_reset"
                element={
                  <AuthGate anyOf={isLoggedOut}>
                    <PasswordResetPage />
                  </AuthGate>
                }
              />
              <Route
                path="password_reset_confirmation"
                element={
                  <AuthGate anyOf={isLoggedOut}>
                    <PasswordResetConfirmationPage />
                  </AuthGate>
                }
              />
              {SHOULD_DISABLE_REGISTER_PAGE ? null : (
                <Route
                  path="register"
                  element={
                    <AuthGate anyOf={isLoggedOut}>
                      <RegisterPage />
                    </AuthGate>
                  }
                />
              )}
              <Route
                path="unlock"
                element={
                  <AuthGate anyOf={isLoggedOut}>
                    <UnlockPage />
                  </AuthGate>
                }
              />
              <Route path="verify" element={<VerifyPage />} />
              <Route
                path="onboarding/*"
                element={
                  <AuthGate anyOf={isLoggedIn}>
                    <OnboardingPage />
                  </AuthGate>
                }
              />
              <Route
                path="*"
                element={
                  <AuthGate anyOf={isLoggedIn}>
                    <DashboardPage />
                  </AuthGate>
                }
              />
            </Routes>
          </Suspense>
        </OnlineMonitor>
      </ErrorBoundary>
    </>
  );
}
